<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputPreview'
export default {
  name: 'DMobilePreview',
  extends: compoment
}
</script>
